import React, { useEffect } from 'react';
import '../styles.scss';
import { Container, Tab, Row, Col, Nav, Stack } from 'react-bootstrap';
import DownloadStassifyApp from 'components/Home/DownloadStassifyApp';
import { useFaqQuery } from 'services';
import parse from 'html-react-parser';
import { sanitizeHtml } from 'utils/sanitizeHtml';
import useTranslate from 'hooks/useTranslate';
import useLocalizationStore from 'store/localization';

export const FAQs: React.FC = () => {
	const { activeLanguage }: any = useLocalizationStore((state) => state);
	const { data, refetch } = useFaqQuery();
	const { translate } = useTranslate();

	useEffect(() => {
		refetch();
	}, [activeLanguage]);

	const firstFaqId = data?.[0]?.id ? `faq${data[0].id}` : '';

	return (
		<section className="static-page bg-white">
			<div className="static-page-banner">
				<div className="static-page-banner-bg terms-banner h-100 w-100 d-flex align-items-center justify-content-center position-relative">
					<div className="static-page-banner-bg-overlay w-100 h-100 position-absolute top-0 left-0"></div>
					<h2 className="fw-bold text-white mb-0">{translate('Common.faq')}</h2>
				</div>
			</div>
			<Container>
				<div className="static-page-content py-80">
					<div className="faqs">
						{data && data.length > 0 ? (
							<Tab.Container defaultActiveKey={firstFaqId}>
								<Row className="faq-tabs">
									<Col md={6}>
										<Nav variant="pills" className="flex-column">
											{data.map((res: any) => (
												<Nav.Item key={res.id}>
													<Nav.Link eventKey={`faq${res.id}`}>
														<div className="d-flex align-items-center justify-content-between gap-5">
															<div>{res.question}</div>
															<i className="ri-arrow-right-line"></i>
														</div>
													</Nav.Link>
												</Nav.Item>
											))}
										</Nav>
									</Col>
									<Col md={6}>
										<Tab.Content className="faq-answer">
											{data.map((res: any) => (
												<Tab.Pane key={res.id} eventKey={`faq${res.id}`}>
													<div>{parse(sanitizeHtml(res.answer.replace(/\n/g, '<br>')))}</div>
												</Tab.Pane>
											))}
										</Tab.Content>
									</Col>
								</Row>
							</Tab.Container>
						) : (
							<Stack style={{ textAlign: 'center' }}>{translate('Common.noDataFound')}</Stack>
						)}
					</div>
				</div>
			</Container>
			<DownloadStassifyApp />
		</section>
	);
};

export default FAQs;
